import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Button } from 'react-bootstrap';
import ConstructionIcon from '@mui/icons-material/Construction';

const EUUnderConstructionPage = () => (
  <div
    className="eu-under-construction"
    style={{
      minHeight: '60vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '2rem 1rem',
    }}
  >
    <Container>
      <Row className="justify-content-center text-center">
        <Col md={8} lg={6}>
          <ConstructionIcon sx={{ fontSize: 64 }} style={{ color: '#6c757d', marginBottom: '1rem' }} />
          <h2 style={{ color: '#333', marginBottom: '1rem', fontWeight: 600 }}>
            EU SDG section under construction
          </h2>
          <p style={{ color: '#6c757d', marginBottom: '1.5rem', fontSize: '1.1rem' }}>
            The EU Sustainable Development Goals section is currently being developed. Please use the UN SDG section for now.
          </p>
          <Button
            as={Link}
            to="/un-sdg"
            variant="primary"
            size="lg"
            style={{ backgroundColor: '#019edb', borderColor: '#019edb' }}
          >
            Go to UN SDG
          </Button>
        </Col>
      </Row>
    </Container>
  </div>
);

export default EUUnderConstructionPage;
